import { getPrefix, getSessionToken } from "../bandung";
import { objectToFormData } from "./helpers";
import Axios from "axios";

const getAnnouncementPrefix = () => `${getPrefix()}/app/announcement`;

const getAnnouncementCreateEndPoint = () => `${getAnnouncementPrefix()}/create`;
const getAnnouncementDeleteEndPoint = () => `${getAnnouncementPrefix()}/delete`;
const getAnnouncementListEndPoint = () => `${getAnnouncementPrefix()}/list`;
const getAnnouncementSendEndPoint = () => `${getAnnouncementPrefix()}/send`;
const getAnnouncementTextLongDescriptionEndPoint = () => `${getAnnouncementPrefix()}/textlongdescription`;
const getAnnouncementUpdateEndPoint = () => `${getAnnouncementPrefix()}/update`;
const getAnnouncementUpdateLongDescriptionEndPoint = () => `${getAnnouncementPrefix()}/updatelongdescription`;
const getAnnouncementViewEndPoint = () => `${getAnnouncementPrefix()}/view`;

const announcementCreate = async ({
  label,
}) => {
  const form = objectToFormData({
    sessionToken: getSessionToken(),
    label: label,
  });
  try {
    const response = await Axios.post(getAnnouncementCreateEndPoint(), form);
    if (!response.data.error) {
      return {
        code: "SUCCESS",
        message: "Announcement successfully created.",
        data: { announcementEntityId: response.data.announcementEntityId },
      };
    } else {
      throw new Error(response.data.error);
    }
  } catch (error) {
    return {
      code: "ERROR",
      message: error.message || "An error occurred.",
    };
  }
};

const announcementDelete = async (announcementEntityId) => {
  const form = objectToFormData({
    sessionToken: getSessionToken(),
    announcementEntityId: announcementEntityId,
  });
  try {
    const response = await Axios.post(getAnnouncementDeleteEndPoint(), form);
    if (!response.data.error) {
      return {
        code: "SUCCESS",
        message: "Announcement deleted successfully",
        data: response.data,
      };
    } else {
      throw new Error(response.data.error);
    }
  } catch (error) {
    return {
      code: "ERROR",
      message: error.message || "An error occurred.",
    };
  }
};

const announcementList = async (page) => {
  const form = objectToFormData({
    sessionToken: getSessionToken(),
    page: page,
  });
  try {
    const response = await Axios.post(getAnnouncementListEndPoint(), form);
    if (!response.data.error) {
      return {
        code: "SUCCESS",
        message: "Announcement list loaded successfully",
        data: response.data,
      };
    } else {
      throw new Error(response.data.error);
    }
  } catch (error) {
    return {
      code: "ERROR",
      message: error.message || "An error occurred.",
    };
  }
};

const announcementSend = async (announcementEntityId) => {
  const form = objectToFormData({
    sessionToken: getSessionToken(),
    announcementEntityId: announcementEntityId,
  });
  try {
    const response = await Axios.post(getAnnouncementSendEndPoint(), form);
    debugger
    if (response.data.confirm) {
      return {
        code: "SUCCESS",
        message: "Announcement successfully sent",
        data: response.data,
      };
    } else {
      throw new Error(response.data.error);
    }
  } catch (error) {
    return {
      code: "ERROR",
      message: error.message || "An error occurred.",
    };
  }
};

const announcementTextLongDescription = async (announcementEntityId) => {
  const form = objectToFormData({
    sessionToken: getSessionToken(),
    announcementEntityId: announcementEntityId,
  });
  try {
    const response = await Axios.post(
      getAnnouncementTextLongDescriptionEndPoint(), form);
    if (!response.data.error) {
      return {
        code: "SUCCESS",
        message: "Long description retrieved successfully.",
        data: decodeURIComponent(response.data),
      };
    } else {
      throw new Error(response.data.error);
    }
  } catch (error) {
    return {
      code: "ERROR",
      message: error.message || "An error occurred.",
    };
  }
};

const announcementUpdate = async ({
  announcementEntityId,
  label,
}) => {
  const form = objectToFormData({
    sessionToken: getSessionToken(),
    announcementEntityId: announcementEntityId,
    label: label,
  });
  try {
    const response = await Axios.post(getAnnouncementUpdateEndPoint(), form);
    if (!response.data.error) {
      return {
        code: "SUCCESS",
        message: "Update successful.",
      };
    } else {
      throw new Error(response.data.error);
    }
  } catch (error) {
    return {
      code: "ERROR",
      message: error.message || "An error occurred.",
    };
  }
};

const announcementUpdateLongDescription = async (
  announcementEntityId, longDescription) => {
  const form = objectToFormData({
    sessionToken: getSessionToken(),
    announcementEntityId: announcementEntityId,
    longDescription: encodeURIComponent(longDescription),
  });
  try {
    const response = await Axios.post(
      getAnnouncementUpdateLongDescriptionEndPoint(),
      form);
    if (response.data.entity) {
      return {
        code: "SUCCESS",
        message: "Long description updated successfully.",
      };
    } else {
      throw new Error(response.data.error);
    }
  } catch (error) {
    return {
      code: "ERROR",
      message: error.message || "An error occurred.",
    };
  }
};

const announcementView = async (announcementEntityId) => {
  const form = objectToFormData({
    sessionToken: getSessionToken(),
    announcementEntityId: announcementEntityId,
  });
  try {
    const response = await Axios.post(getAnnouncementViewEndPoint(), form);
    if (!response.data.error) {
      return {
        code: "SUCCESS",
        message: "Announcement loaded successfully",
        data: response.data,
      };
    } else {
      throw new Error(response.data.error);
    }
  } catch (error) {
    return {
      code: "ERROR",
      message: error.message || "An error occurred.",
    };
  }
};

export {
  announcementCreate,
  announcementDelete,
  announcementList,
  announcementSend,
  announcementTextLongDescription,
  announcementUpdate,
  announcementUpdateLongDescription,
  announcementView,
};